/*
    author：peter (185832959@qq.com)
    date：2018-07-04
*/
import { getTypes, getModule, getStore } from '../utils/storeUtil'
import { getter, mutation, action } from '../utils/vuexUtil'
import { setToken, removeToken, setCompanyToken } from 'common/auth'
import userApi from 'api/modules/user'
import * as router from '@/router'

export const storeName = 'user'

/** state **/
let state = {
    user: {},
    userInfo: {},
    loggined: false,
    redirectUrl: '',
    token: null,
    changeOrg: false,
    loadedInfo: false,
    addRouters: []
}

/** getters **/
let getters = getter(state, {
    user: state => state.user,
    loggined: state => state.loggined,
    userInfo: state => state.userInfo,
    changeOrg: state => state.changeOrg,
    redirectUrl: state => state.redirectUrl,
    token: state => state.token,
    loadedInfo: state => state.loadedInfo,
    addRouters: state => state.addRouters
})

/** mutations **/
let mutations = mutation(state, {
    SET_USER(state, data) {
        if (data) {
            state.user = Object.assign({}, data)
            // storage.set('user', state.user)
            state.token = data.loginToken
            setToken(data.loginToken)
            setCompanyToken(data.companyToken)
            state.loggined = true
        } else {
            // storage.set('user', '')
            removeToken(storeName)
            state.user = null
            state.loggined = false
            state.token = null
        }
    },
    SET_USER_INFO(state, data) {
        if (data) {
            state.userInfo = Object.assign({}, data)
            state.loadedInfo = true
        } else {
            state.userInfo = null
            state.loadedInfo = false
        }
    },
    SET_REDIRECT_URL(state, val) {
        state.redirectUrl = val
    },
    SET_CHANGE_ORG(state, val) {
        state.changeOrg = val
    },
    SET_ROUTERS(state) {
        state.addRouters = router.constantStaticMap
        state.isLoadedRoutes = true
    }
})

/** actions **/
let actions = action(state, {
    async setUser({ commit }, value) {
        commit('SET_USER', value)
    },
    async setUserInfo({ commit }, value) {
        commit('SET_USER_INFO', value)
    },
    async getUserInfo({ commit }) {
        return new Promise((resolve, reject) => {
            userApi.fetchUserInfo().then((data) => {
                if (!data) {
                    // eslint-disable-next-line prefer-promise-reject-errors
                    reject('error')
                }
                commit('SET_USER_INFO', data)
                resolve(data)
            }).catch((error) => {
                reject(error)
            })
        })
    },
    changeOrg({ commit }, value) {
        commit('SET_CHANGE_ORG', value)
    },
    setRedirectUrl({ commit }, value) {
        commit('SET_REDIRECT_URL', value)
    },
    async generateRoutes({ commit }) {
        return new Promise((resolve) => {
            commit('SET_ROUTERS')
            resolve()
        })
    }
})

/** module store **/
let store = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

/** exports **/
export let types = getTypes(store)
export let module = getModule(storeName)
export let Store = getStore(module, types)

export default store



// WEBPACK FOOTER //
// ./src/store/modules/user.js